
// 電話番号チェック
window.checkTelNumber = function (id) {
    setNormal(id);
    let telNo =  $(id).val().trim();
    if (!telNo) {
        return false;
    }

    // 該当加盟店コードのとき電話番号2をCIMコードとして扱う
    if (data.collaborator_code == data.cimCode_collaboratorCode && id == '#corp_phone2_number1') {
        // CIMコードフォーマットチェック
        if (!telNo.match(/\'[0-9]{4}$/)) {
            $(id + '_error').text('CIMコードを正しく入力してください。');
            setError(id);
            return true;
        }
    } else {
        let itemLabel = data.attributes[$(id).attr('name')];
        // 電話番号フォーマットチェック
        if (!telNo.match(/^0[0-9]{9,10}$/)) {
            $(id + '_error').text(itemLabel + 'を正しく入力してください。');
            setError(id);
            return true;
        }
    }
    return false;
}

// メールアドレス妥当性チェック
window.checkMailAddress = function (id, isRequied = false)
{
    let mailText = $(id).val().trim();
    let itemLabel = data.attributes[$(id).attr('name')];

    if (!isRequied && !mailText) {
        return false;
    } else if (isRequied && mailText == '') {

        $(id + '_error').text(itemLabel + 'を入力してください。');
        setError(id);
    } else if ( !mailText.match(/^[A-Za-z0-9]+[\w\.-]+@[\w\.-]+\.\w{2,}$/)){
        $(id + '_error').text(itemLabel + 'を正しく入力してください。');
        setError(id);
        return true;
    }
    return false;
}

// 確認用メールアドレス一致チェック
window.checkMailAddressConfirm = function (id) {
    if ($(id).val().trim() != $(id + '_confirm').val().trim()) {
        setError(id + '_confirm');
        $(id + '_confirm_error' ).text( 'メールアドレス(確認)とメールアドレスには同じ値を指定してください。');
    }
}

window.checkReminderQuestion = function (isRegist = true) {
    setNormal('#input_reminder_question');
    setNormal('#input_reminder_answer');
    if (!$('#input_reminder_question').val().trim() && !$('#input_reminder_answer').val().trim()) {
        // 両方とも空白
        return false;
    } else if ($('#input_reminder_question').val().trim() && $('#input_reminder_answer').val().trim()) {
        // 両方とも指定あり
    } else {
        // どちらか片方空白
        if (!$('#input_reminder_question').val().trim()) {
            $('#input_reminder_question_error').text('連想質問答えを指定する場合は、パスワード連想質問も指定してください。');
            setError('#input_reminder_question');
        }
        if (!$('#input_reminder_answer').val().trim() && isRegist) {
            $('#input_reminder_answer_error').text('パスワード連想質問を指定する場合は、連想質問答えも指定してください。');
            setError('#input_reminder_answer');
        }
    }
    // 桁数チェック
    if ($('#input_reminder_question').val().trim().length > 26) {
        $('#input_reminder_question_error').text('パスワード連想質問は、26文字以下で入力してください。');
        setError('#input_reminder_question');
    }
    if ($('#input_reminder_answer').val().trim().length > 26) {
        $('#input_reminder_answer_error').text('連想質問答えは、26文字以下で入力してください。');
        setError('#input_reminder_answer');
    }
}

//必須でない電話番号のチェックとフォーカス離脱でエラーを解除
window.checkTelNum = function ( idPrefix ){
    var id = '#' + idPrefix;
    var id1 = id + '1';
    $(id1).blur(function(){
        setNormal(id1);
        let telNo =  $(id1).val().trim();
        if (!telNo) {
            return false;
        }

        // 該当加盟店コードのとき電話番号2をCIMコードとして扱う
        if (data.collaborator_code == data.cimCode_collaboratorCode && id1 == '#corp_phone2_number1') {
            // CIMコードフォーマットチェック
            if (!telNo.match(/\'[0-9]{4}$/)) {
                $(id1 + '_error').text('CIMコードを正しく入力してください。');
                setError(id1);
                return true;
            }
            return false;
        }

        // 電話番号フォーマットチェック
        if (!telNo.match(/^0[0-9]{9,10}$/) && telNo) {
            $(id1 + '_error').text(data.attributes[$(id1).attr('name')] + 'を正しく入力してください。');
            setError(id1);
        }
    });
}

//メール入力欄と確認欄のチェック
window.checkMailConfirm = function ( formId, idPrefix, required ){
    var id = '#' + idPrefix;
    var confirm = id + '_confirm';
    $(formId).on('blur', id, function(){
        setNormal(id);
        setNormal(confirm);
        checkMailAddress(id, required);
        checkMailAddressConfirm(id);
        if ( $(this).hasClass('is-invalid') || $(confirm).hasClass('is-invalid') ){
            return;
        }
        if ( $(confirm).val().trim() == '' ){
            if ( $(this).val().trim() == '' ){
                //requiredの時はここには来ない、requiredでないときは両方空は許容
                return;
            }
            setError(confirm);
            $(confirm + '_error' ).text( '確認用メールアドレスを入力してください。');
        }else if ( $(this).val().trim() !== $(confirm).val().trim() ){
            checkMailAddressConfirm(confirm);
        }
    });
    $(formId).on('blur', confirm, function(){
        setNormal(confirm);
        if ( $(id).val().trim() == $(this).val().trim() ){
            //ok
        }else{
            $(confirm + '_error').text('メールアドレス(確認)とメールアドレスには同じ値を指定してください。');
            setError(confirm);
        }
    });
}

window.checkPassword = function (isRequired = false) {
    var id = '#password';
    var id_confirm = id + '_confirm';
    var id_error = id + '_error';

    setNormal(id);
    setNormal(id_confirm);

    var val = $(id).val().trim();
    var val_confirm = $(id_confirm).val().trim();

    if (!val && !val_confirm && !isRequired) {
        return;
    }
    if (val == '') {
        $(id_error).text('パスワードを入力してください。');
        setError(id);
    } else if (val.length < 8 || val.length > 64) {
        $(id_error).text('パスワードは、8文字以上64文字以下で入力してください。');
        setError(id);
    } else if (!val.match(/^[a-zA-Z0-9\-\.@_]+$/)) {
        $(id_error).text('パスワードを正しく入力してください。');
        setError(id);
    } else {
        //ok
        if ($(id_confirm).val().trim() == '') {
            setError(id_confirm);
            $('#password_confirm_error').text('確認用パスワードを入力してください。');
        } else if ($(id_confirm).val().trim() != val) {
            setError(id_confirm);
            $('#password_confirm_error').text('パスワード(確認)とパスワードには同じ値を指定してください。');
        }
    }
}

//カタカナ入力チェック（スペース許容）
window.checkKanaExcludeSpace = function (id, required){
    var val = $(id).val();
    if ( val == '' ){
        if ( required ){
            $(id + '_error').text(data.attributes[$(id).attr('name')] + 'を入力してください。');
            setError(id);
        }else{
            setNormal(id);
        }
    }else if ( !val.match(/^[ァ-ヾ〜ー　]+$/) ){
        $(id + '_error').text(data.attributes[$(id).attr('name')] + 'はカタカナで入力してください。');
        setError(id);
    }else{
        setNormal(id);
    }
}

//カタカナ入力チェック
window.checkKana = function (id, required){
    var val = $(id).val().trim();
    if ( val == '' ){
        if ( required ){
            $(id + '_error').text(data.attributes[$(id).attr('name')] + 'を入力してください。');
            setError(id);
        }else{
            setNormal(id);
        }
    }else if ( !val.match(/^[ァ-ヾ〜ー−]+$/) ){
        $(id + '_error').text(data.attributes[$(id).attr('name')] + 'はカタカナで入力してください。');
        setError(id);
    }else{
        setNormal(id);
    }
}

window.controllDispPassword = function () {
    let password = '#password';
    let passcheck = '#js-passcheck';

    $(passcheck).change(function () {
        if ($(this).prop('checked')) {
            $(password).attr('type', 'url');
        } else {
            $(password).attr('type', 'password');
        }
    });
}

//生年月日の選択欄チェック
window.checkBirthday = function (){
    var year = '#birthday_year';
    var month = '#birthday_month';
    var day = '#birthday_day';
    $(year).change(function(){
        setNormal(year);
        if ( $(year).val() == '' ){
            $(year + '_error_message' ).text('選択してください。');
            setError(year);
        }else{
            if ( $(month).val() != '' && $(day).val() != '' ){
                if ( !isDayExists( $(year).val(), $(month).val(), $(day).val() ) ){
                    $(day + '_error_message' ).text('日付が正しくありません。');
                    setError(day);
                    setNormal(year);
                    setNormal(month);
                } else {
                    $(day + '_error_message' ).text('');
                    setNormal(day);
                    setNormal(year);
                    setNormal(month);
                }
            }
        }
    });
    $(month).change(function(){
        setNormal(month);
        if ( $(month).val() == '' ){
            $(month + '_error_message' ).text('選択してください。');
            setError(month);
        }else{
            if ( $(year).val() != '' && $(day).val() != '' ){
                if ( !isDayExists( $(year).val(), $(month).val(), $(day).val() ) ){
                    $(day + '_error_message' ).text('日付が正しくありません。');
                    setError(day);
                    setNormal(year);
                    setNormal(month);
                } else {
                    $(day + '_error_message' ).text('');
                    setNormal(day);
                    setNormal(year);
                    setNormal(month);
                }
            }
        }
    });
    $(day).change(function(){
        setNormal(day);
        if ( $(day).val() == '' ){
            $(day + '_error_message' ).text('選択してください。');
            setError(day);
        }else{
            if ( $(year).val() != '' && $(month).val() != '' ){
                if ( !isDayExists( $(year).val(), $(month).val(), $(day).val() ) ){
                    $(day + '_error_message' ).text('日付が正しくありません。');
                    setError(day);
                    setNormal(year);
                    setNormal(month);
                }
            }
        }
    });
}

window.setValidationStatusforRadio = function (name) {
    if ($('[name="' + name + '"]').is(':checked')) {
        setNormal('#' + name);
    } else {
        $('#' + name + '_error').text('選択してください。');
        setError('#' + name);
    }
}

//日付入力が正しいかを返す
window.isDayExists = function ( year, month, day ){
    return moment([year,month,day], 'YYYY-MM-DD').isValid();
}

